module.exports = __webpack_public_path__ + "img/eau.4a40a180.png";